import React from "react";
import PropTypes from "prop-types";
import { CircularProgress, Typography } from "@material-ui/core";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  width: 100%;
  text-align: center;
  padding: 32px 8px;
`;

const Message = styled(Typography)`
  padding: 15px;
`;

const JobInProgressOverlay = ({ message, inProgress }) => {
  const { t } = useTranslation();

  if (!inProgress) {
    return (
      <Container>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <Container>
      <Message color="textSecondary" variant="h6">
        {message}
      </Message>
      <CircularProgress />
      <Message color="textSecondary" variant="h4">
        {t("common.messages.returnWhenDone")}
      </Message>
    </Container>
  );
};

JobInProgressOverlay.propTypes = {
  message: PropTypes.string,
  inProgress: PropTypes.bool
};

JobInProgressOverlay.defaultProps = {
  message: "",
  inProgress: true
};

export default JobInProgressOverlay;
